const delCost = 1;
const insCost = 1;
const replaceCost = 1;
const matchCost = 0;

export const calcEditDistance = (src: string, dst: string) => {
    const rows = src.length + 1;
    const columns = dst.length + 1;
    const d = init(rows, columns);

    for(let r = 1; r < rows; r++) {
        for(let c = 1; c < columns; c++) {
            const del = d[r - 1][c] + delCost;
            const ins = d[r][c - 1] + insCost;
            const match = d[r - 1][c - 1] + ((src[r - 1]===dst[c - 1]) ? matchCost : replaceCost);
            d[r][c] = Math.min(del, ins, match);
        }
    }

    return d[rows - 1][columns - 1];
}

const init = (rows: number, columns: number): (number[])[] => {
    const matrix = new Array<number[]>(rows);
    for(let r = 0; r < rows; r++) {
        matrix[r] = new Array<number>(columns);
    }

    // replacement or insertion a symbol cost 1
    for(let r = 0; r < rows; r++) {
        matrix[r][0] = r;
    }
    for(let c = 0; c < columns; c++) {
        matrix[0][c] = c;
    }
    
    return matrix;
}


// WEBPACK FOOTER //
// ./src/utils/edit-distance.ts